export default __webpack_public_path__ + "static/media/flag-cocos-(keeling)-islands.9a65ab6d.svg";